
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  HiOutlinePlay,
  HiOutlineVideoCamera,
  HiOutlineArrowUpRight,
  HiOutlineCalendarDays,
} from "react-icons/hi2";

import VideoThumbnail from "../videos/VideoThumbnail";

/* ============================================
   VIDEO CARD
============================================ */

function VideoCard({
  video,
  category,
  index = 0,
}) {
  const { i18n } = useTranslation();

  const isEnglish = (
    i18n.resolvedLanguage ||
    i18n.language ||
    "ar"
  )
    .toLowerCase()
    .startsWith("en");

  const title = isEnglish
    ? video?.titleEn || video?.titleAr
    : video?.titleAr || video?.titleEn;

  const content = {
    label: isEnglish
      ? "LEGAL VIDEO"
      : "فيديو قانوني",

    watch: isEnglish
      ? "Watch Video"
      : "شاهد الفيديو",
  };

  const number = String(index + 1).padStart(2, "0");

  return (
    <Link
      to="/VedioDetails"
      state={{
        VideoData: video,
        category,
      }}
      onClick={() => {
        window.scrollTo(0, 0);
      }}
      aria-label={`${content.watch}: ${title}`}
      className="
        group relative flex h-full min-w-0
        flex-col overflow-hidden

        rounded-[20px]

        border border-[#D9E4EC]
        bg-white

        shadow-[0_10px_35px_rgba(15,39,55,0.05)]

        transition-all duration-300
        ease-out

        hover:-translate-y-1.5
        hover:border-[#C19B60]/45
        hover:shadow-[0_20px_50px_rgba(15,39,55,0.12)]

        focus-visible:outline-none
        focus-visible:ring-2
        focus-visible:ring-[#C19B60]

        dark:border-white/10
        dark:bg-[#1B3549]
        dark:shadow-none

        dark:hover:border-[#D7B77F]/35
      "
    >
      {/* ======================================
          VIDEO IMAGE
      ====================================== */}

     
<div
  className="
    relative aspect-video
    w-full shrink-0
    overflow-hidden
    bg-[#142C40]
  "
>
  <VideoThumbnail
    image={video?.Image}
    alt={title || ""}
    className="h-full w-full"
  />


        {/* Cinematic overlay */}
        <div
          aria-hidden="true"
          className="
            pointer-events-none
            absolute inset-0

            bg-gradient-to-t
            from-[#071522]/65
            via-[#071522]/10
            to-transparent
          "
        />

        {/* Video number */}
        <div
          className="
            absolute end-4 top-4

            flex h-9 min-w-9
            items-center justify-center

            rounded-lg
            border border-white/20
            bg-[#102031]/60

            px-3

            font-kufi text-xs font-semibold
            tabular-nums text-white
            backdrop-blur-lg
          "
        >
          {number}
        </div>

        {/* Play button visual */}
        <div
          aria-hidden="true"
          className="
            absolute left-1/2 top-1/2

            flex h-[68px] w-[68px]
            -translate-x-1/2
            -translate-y-1/2

            items-center justify-center

            rounded-full
            border border-white/50
            bg-white/15

            text-white
            backdrop-blur-lg

            shadow-[0_10px_30px_rgba(0,0,0,0.20)]

            transition-all duration-300

            group-hover:scale-110
            group-hover:border-white/80
            group-hover:bg-white/25
          "
        >
          <HiOutlinePlay
            size={30}
            className="ms-0.5"
          />
        </div>

        {/* Bottom video label */}
        <div
          className="
            absolute bottom-4 start-4

            inline-flex items-center gap-2

            rounded-lg
            border border-white/15
            bg-[#102031]/55

            px-3 py-2
            backdrop-blur-lg
          "
        >
          <HiOutlineVideoCamera
            size={16}
            aria-hidden="true"
            className="text-[#D7B77F]"
          />

          <span className="font-kufi text-xs font-semibold text-white">
            {content.label}
          </span>
        </div>
      </div>

      {/* ======================================
          VIDEO INFORMATION
      ====================================== */}

      <div className="flex flex-1 flex-col px-6 pb-6 pt-6 sm:px-7 sm:pb-7">

        {/* Date */}
        {video?.date && (
          <div
            className="
              mb-4 flex items-center gap-2

              font-kufi text-xs
              text-[#71879A]

              dark:text-[#B5C8D6]
            "
          >
            <HiOutlineCalendarDays
              size={17}
              aria-hidden="true"
            />

            <span>{video.date}</span>
          </div>
        )}

        {/* Video title */}
        <h3
          className="
            font-kufi
            text-lg font-bold
            leading-[1.8]

            line-clamp-3

            text-[#19344D]
            dark:text-[#F5F8FB]

            transition-colors duration-300

            group-hover:text-[#A47D41]
            dark:group-hover:text-[#E5C995]

            sm:text-xl
          "
        >
          {title}
        </h3>

        {/* ==================================
            CARD FOOTER
        ================================== */}

        <div className="mt-auto pt-8">

          <div className="mb-5 h-px bg-[#DFE7ED] dark:bg-white/10" />

          <div className="flex items-center justify-between gap-4">

            <span
              className="
                font-kufi text-sm font-semibold

                text-[#19344D]
                dark:text-white
              "
            >
              {content.watch}
            </span>

            <span
              className="
                flex h-11 w-11
                shrink-0 items-center
                justify-center

                rounded-xl
                border border-[#D9E4EC]
                bg-[#F0F5F8]

                text-[#19344D]

                transition-all duration-300

                group-hover:border-[#19344D]
                group-hover:bg-[#19344D]
                group-hover:text-white

                dark:border-white/10
                dark:bg-white/[0.07]
                dark:text-white

                dark:group-hover:border-white/25
                dark:group-hover:bg-white/15
              "
            >
              <HiOutlineArrowUpRight
                size={20}
                aria-hidden="true"
                className="rtl:-scale-x-100"
              />
            </span>

          </div>
        </div>
      </div>
    </Link>
  );
}

export default VideoCard;
